import React, { useState } from "react";
import nextchatalottlogo from "../../assets/images/svg/next-modal-chatalott-logo.svg";
import { BackArrowIcon } from "../common/Icon";
import bessieCooper from "../../assets/images/today-workflow/bessie_cooper_img.svg";
import { useStateProvider } from "../common/StateProvider";
import AttachFileModal from "../common/AttachFileModal";
const NextModal = ({ setNextModal }) => {
  const { setQuickActionModal } = useStateProvider();
  const [attachFile, setAttachFile] = useState();
  const { profileAttachFileModal, setprofileAttachFileModal } =
    useStateProvider(); //ATTACH FILE MODAL

  return (
    <>
      <div className=" bg-white rounded-[20px] shadow-[0px_12px_29px_0px_rgba(0,_0,_0,_0.04)] w-[320px] xs:w-[350px] ">
        <div className="flex items-center py-3 px-5">
          <span onClick={() => setNextModal(false)} className=" cursor-pointer">
            <BackArrowIcon />
          </span>
          <img
            className=" w-full max-w-[120px] ps-[13px]"
            src={nextchatalottlogo}
            alt="chatalottlogo"
          />
        </div>
        <span className="h-[1px] bg-black block  w-[330px] mx-auto opacity-10 "></span>
        <div className=" flex flex-col items-center pt-[10px]">
          <img
            className="max-w-[30px] w-full"
            src={bessieCooper}
            alt="bessieCooper-img"
          />
          <h2 className="text-sm font-semibold text-black pt-[6px]">
            Bessie Cooper
          </h2>
        </div>
        <div className=" flex flex-col px-[55px] pt-3">
          {/* <button className="text-[10px] 3xl:text-[14px] font-normal text-black opacity-40 py-2 text-start hover:bg-primary hover:border-transparent hover:opacity-100 hover:text-white duration-300 px-3 rounded-lg border border-solid border-[rgba(146,_146,_146,_0.30)] mb-2">
            Meeting Link
          </button> */}
          <input
            className="text-[10px] 3xl:text-[14px]  font-normal text-black outline-primary placeholder:text-black/40 w-full px-3 py-2  rounded-lg border border-solid border-[rgba(146,_146,_146,_0.30)] mb-2"
            placeholder="Meeting Link"
            type="text"
            required
          />
          {/* <button className="text-[10px] 3xl:text-[14px] font-normal text-black opacity-40 py-2 text-start hover:bg-primary hover:border-transparent hover:opacity-100 hover:text-white duration-300 px-3 rounded-lg border border-solid border-[rgba(146,_146,_146,_0.30)] mb-2">
            Add Notes
          </button> */}
          <input
            className="text-[10px] 3xl:text-[14px]  font-normal text-black outline-primary placeholder:text-black/40 w-full px-3 py-2  rounded-lg border border-solid border-[rgba(146,_146,_146,_0.30)] mb-2"
            placeholder="Add Notes"
            type="text"
            required
          />
          <button
            onClick={() => setprofileAttachFileModal(true)}
            className="text-[10px] 3xl:text-[14px] font-normal text-black/40 py-2 text-start hover:bg-primary hover:border-transparent hover:opacity-100 hover:text-white duration-300 px-3 rounded-lg border border-solid border-[rgba(146,_146,_146,_0.30)]">
            Attach File
          </button>

          <div className="pt-[18px] flex justify-center pb-4">
            <button
              onClick={() => setQuickActionModal(false)}
              className="text-sm font-semibold text-white py-[10px] px-[26px] rounded-[37px] bg-primary hover:bg-white xl:w-[90px] hover:text-primary border border-solid border-transparent hover:border-primary duration-300">
              Save
            </button>
          </div>
          <div className="fixed top-[25%] right-0 md:right-[14%] lg:right-[11%] xl:right-[20%] xl:top-[28%] z-[9999] 3xl:top-[33%] 3xl:right-[6%] ">
            {profileAttachFileModal && (
              <AttachFileModal
                attachFileModal={profileAttachFileModal}
                setAttachFileModal={setprofileAttachFileModal}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NextModal;
